import { BrandLogo } from '../ui/Brand';
import { ThemeToggle } from '../theme/ThemeToggle';

/**
 * Full-viewport centered card, shared by bootstrap/login/invite screens.
 *
 * A dedicated layout rather than reusing `.modal-backdrop`: these screens
 * replace the whole app (there is nothing behind them to dim), and unlike a
 * modal there is no backdrop click or Escape to dismiss — the user has to
 * actually resolve the form.
 */
export function AuthScreen({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}) {
  return (
    <div className="auth-screen">
      <div className="auth-theme">
        <ThemeToggle />
      </div>
      <div className="auth-card">
        <div className="auth-brand">
          <BrandLogo markSize={34} />
        </div>
        <h1 className="auth-title">{title}</h1>
        {subtitle && <p className="auth-subtitle">{subtitle}</p>}
        {children}
        {footer && <div className="auth-footer">{footer}</div>}
      </div>
    </div>
  );
}

export function AuthError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div className="auth-error" role="alert">
      {message}
    </div>
  );
}
